import { render, staticRenderFns } from "./HotpointScene.vue?vue&type=template&id=e46f3b84&scoped=true"
import script from "./HotpointScene.vue?vue&type=script&lang=js"
export * from "./HotpointScene.vue?vue&type=script&lang=js"
import style0 from "./HotpointScene.vue?vue&type=style&index=0&id=e46f3b84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46f3b84",
  null
  
)

export default component.exports